import { render, staticRenderFns } from "./VAxis.vue?vue&type=template&id=dc01cf80&"
import script from "./VAxis.vue?vue&type=script&lang=js&"
export * from "./VAxis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports